import Vue from 'vue';
import alert from '@/components/Modal/ModalAlert.vue';

const Alert = Vue.extend(alert);

const alertFun = function (options) {
  const Instance = new Alert({
    data: {
      message: options?.message || 'message',
      title: options.title || 'title',
      confirmText: options?.confirm || '確定',
      cancelText: options?.cancel || '取消',
    },
  });
  if (options && options.slot) {
    Instance.$slots.main = options.slot;
  }
  const vm = Instance.$mount();
  document.body.appendChild(vm.$el);
  return vm.init();
};

export default alertFun;
